import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {GroupsComponent} from './groups.component';

const routes: Routes = [
  {path: 'targetgroups/groups', component: GroupsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class GroupsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/groups/groups-routing.module.ts